import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  withCredentials: true // 允许携带cookie
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('Request URL:', config.baseURL + config.url)
    console.log('Request Data:', config.data)
    return config
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    console.log('Response:', response.data)
    const res = response.data
    
    // 如果是Result格式的响应
    if (Object.prototype.hasOwnProperty.call(res, 'success')) {
      // 直接返回后端的Result对象，让前端处理success字段
      return {
        success: res.success,
        code: res.success ? 200 : 500,
        data: res.data,
        msg: res.msg // 保持与后端一致的字段名
      }
    }
    
    // 其他格式直接返回
    return res
  },
  error => {
    console.error('Response Error:', error)
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error('Error Status:', error.response.status)
      console.error('Error Data:', error.response.data)
      return Promise.reject(new Error(error.response.data?.msg || '服务器响应错误'))
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('No Response:', error.request)
      return Promise.reject(new Error('服务器无响应，请检查后端服务是否启动'))
    } else {
      // 发送请求时出了点问题
      console.error('Request Error:', error.message)
      return Promise.reject(new Error('请求发送失败'))
    }
  }
)

export default service 